import { Check, Loader2 } from "lucide-react";
import { LoadingCard } from "@/components/LoadingCard";
import { cn } from "@/lib/utils";
import type { ClipsLoadingStepId, ClipsLoadingStepState } from "@/lib/clips/resolveClipsPageLoading";

interface ClipsLoadingStatusProps {
  title: string;
  steps: Array<{
    id: ClipsLoadingStepId;
    label: string;
    state: ClipsLoadingStepState;
  }>;
}

export const ClipsLoadingStatus = ({ title, steps }: ClipsLoadingStatusProps) => {
  return (
    <LoadingCard message={title} showIndicator={false}>
      <ol className="space-y-3 text-left" data-testid="clips-loading-steps">
        {steps.map((step) => (
          <li
            key={step.id}
            data-step={step.id}
            data-state={step.state}
            className="flex items-center gap-3"
          >
            <span
              className={cn(
                "flex h-5 w-5 shrink-0 items-center justify-center rounded-full border",
                step.state === "complete" && "border-primary bg-primary text-primary-foreground",
                step.state === "active" && "border-primary bg-primary/10 text-primary",
                step.state === "pending" && "border-border bg-muted text-muted-foreground",
              )}
            >
              {step.state === "complete" && <Check className="h-3 w-3" aria-hidden="true" />}
              {step.state === "active" && (
                <Loader2 className="h-3 w-3 animate-spin" aria-hidden="true" />
              )}
            </span>
            <span
              className={cn(
                "text-sm",
                step.state === "pending" ? "text-muted-foreground" : "text-foreground",
              )}
            >
              {step.label}
            </span>
          </li>
        ))}
      </ol>
    </LoadingCard>
  );
};
